fx.ns("shared.stage", class ToolBarStateButton extends shared.stage.ToolBarButton{
    
    constructor(command, component, container)
    {
        super(command, component, container);

        this._state = false;
    }

    onReady()
    {
        super.onReady();

        this.state = this.component[this.command.field];
    }

    selectionChanged()
    {
        super.selectionChanged();
        
        this.state = this.component[this.command.field];
    }

  


    get state()
    {
        return this._state;
    }

    set state(val)
    {
        this._state = val;

        if (this._state)
            this.addClass("pushed");
        else
            this.removeClass("pushed");
    }

    click(){
        this.state = !this.state;

        this.action(this.state);
    }


    
});